import { EventTriggerFixed } from '@user-portal/wikr-analytics';

import { SchemaKeysMap } from '../types/analytics';

export const schemaKeysMap: SchemaKeysMap = {
  // login
  [EventTriggerFixed.loginSuccess]: 'iglu:com.welltech.walk_fit.web/login_success/jsonschema/1-2-0',
};
